<template>
  <v-dialog v-model="dialog" max-width="800" scrollable persistent :dark="$vuetify.theme.dark">
    <v-card :dark="$vuetify.theme.dark">
      <v-card-title class="d-flex align-center">
        <v-icon left>fas fa-car</v-icon>
        Gestionar modelos
        <v-spacer />
        <v-btn
          v-if="filtro.empresa && filtro.empresa.id"
          color="success"
          small
          fab
          title="Sincronizar con SAI"
          :loading="syncing"
          @click="sincronizar"
        >
          <v-icon>fas fa-sync</v-icon>
        </v-btn>
        <v-btn icon @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form @submit.prevent="buscar">
          <v-row dense class="mt-5">
            <v-col cols="12" sm="4" md="3">
              <v-autocomplete
                v-model="filtro.empresa"
                label="Empresa"
                :items="familias"
                item-text="nombre"
                return-object
                hide-details
                outlined
                dense
                @change="setCodigosModelos"
              />
            </v-col>
            <v-col cols="12" sm="4" md="3" class="d-flex align-center">
              <v-switch
                v-model="filtro.verHabilitados"
                label="Ver habilitados"
                hide-details
                class="mt-0"
              />
            </v-col>
            <v-col cols="12">
              <BtnFiltro :loading="load" clase="mt-0" @clear="limpiarFiltro" />
            </v-col>
          </v-row>
        </v-form>

        <v-data-table
          class="cebra mt-3"
          item-key="Modelo_id"
          :headers="headers"
          :items="modelosFiltrados"
          :search="filtro.busqueda"
          :loading="load"
          dense
          no-data-text="No hay datos disponibles"
        >
          <template v-slot:top>
            <v-row class="px-2 py-2" align="center">
              <v-col cols="12" md="4">
                <SearchDataTable v-model="filtro.busqueda" />
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <BtnConfirmar
              :icono="item.Inhabilitado ? 'fas fa-check' : 'fas fa-ban'"
              :color="item.Inhabilitado ? 'success' : 'error'"
              :title="item.Inhabilitado ? 'Habilitar' : 'Inhabilitar'"
              :texto="`¿${item.Inhabilitado ? 'Habilitar' : 'Inhabilitar'} el modelo <strong>${item.Modelo}</strong>?`"
              :icon_button="true"
              :small="true"
              @action="item.Inhabilitado ? habilitar(item) : inhabilitar(item)"
            />
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import BtnFiltro from '../util/BtnFiltro.vue'
import BtnConfirmar from '../util/BtnConfirmar.vue'
import SearchDataTable from '../util/SearchDataTable.vue'

export default {
  name: 'ModalModelosV2',
  components: { BtnFiltro, BtnConfirmar, SearchDataTable },
  props: {
    value: { type: Boolean, default: false }
  },
  data() {
    return {
      load: false,
      syncing: false,
      modelos: [],
      modelosFiltrados: [],
      filtro: {
        empresa: null,
        busqueda: '',
        verHabilitados: true
      },
      headers: [
        { text: 'Marca', value: 'empresa_nombre' },
        { text: 'Cod. Modelo', value: 'Modelo' },
        { text: 'Modelo', value: 'Descripcion' },
        { text: 'Acciones', value: 'actions', sortable: false, width: '100' }
      ]
    }
  },
  computed: {
    dialog: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    },
    ...mapState(['familias', 'empresas'])
  },
  watch: {
    value(v) {
      if (v && this.familias && this.familias.length === 1) {
        this.filtro.empresa = this.familias[0]
        this.setCodigosModelos()
      }
    },
    'filtro.verHabilitados'() {
      this.aplicarFiltroTabla()
    }
  },
  methods: {
    aplicarFiltroTabla() {
      this.modelosFiltrados = this.modelos.filter(m => m.Inhabilitado === !this.filtro.verHabilitados)
    },
    async setCodigosModelos() {
      this.filtro.busqueda = ''
      if (!this.filtro.empresa || !this.filtro.empresa.id) {
        this.modelos = []
        this.modelosFiltrados = []
        return
      }
      this.load = true
      const res = await this.$store.dispatch('preciosModelosV2/getModelosByFamilia', this.filtro.empresa.id)
      this.load = false
      if (res.exito === 1 && res.data) {
        this.modelos = res.data.map(m => ({
          ...m,
          empresa_nombre: (this.empresas || []).find(e => e.id === m.Empresa_id)?.nombre || m.empresa_nombre
        }))
        this.aplicarFiltroTabla()
      } else {
        this.modelos = []
        this.modelosFiltrados = []
      }
    },
    async buscar() {
      if (!this.filtro.empresa || !this.filtro.empresa.id) {
        this.$store.dispatch('show_snackbar', { color: 'warning', text: 'Seleccione una empresa.' })
        return
      }
      await this.setCodigosModelos()
    },
    async sincronizar() {
      if (!this.filtro.empresa || !this.filtro.empresa.id) {
        this.$store.dispatch('show_snackbar', { color: 'warning', text: 'Seleccione una empresa.' })
        return
      }
      this.syncing = true
      const empresaId = this.filtro.empresa.id
      const res = await this.$store.dispatch('modelos/sincronizarModelos', { Empresa_id: empresaId })
      this.syncing = false
      if (res && (res.exito === 1 || res.exito === true)) {
        this.$store.dispatch('show_snackbar', { color: 'success', text: res.message || 'Modelos sincronizados.' })
        await this.setCodigosModelos()
      } else {
        this.$store.dispatch('show_snackbar', { color: 'error', text: res?.message || 'Error al sincronizar.' })
      }
    },
    async inhabilitar(item) {
      const payload = {
        modelo: item.Modelo,
        action: true,
        marca: item.Empresa_id,
        sai_modelo_id: item.sai_modelo_id
      }
      this.load = true
      await this.$store.dispatch('modelos/gestionarModelo', payload)
      this.load = false
      this.$store.dispatch('show_snackbar', { color: 'success', text: 'Modelo inhabilitado.' })
      item.Inhabilitado = true
      this.aplicarFiltroTabla()
    },
    async habilitar(item) {
      const payload = {
        modelo: item.Modelo,
        action: false,
        marca: item.Empresa_id,
        sai_modelo_id: item.sai_modelo_id
      }
      this.load = true
      await this.$store.dispatch('modelos/gestionarModelo', payload)
      this.load = false
      this.$store.dispatch('show_snackbar', { color: 'success', text: 'Modelo habilitado.' })
      item.Inhabilitado = false
      this.aplicarFiltroTabla()
    },
    limpiarFiltro() {
      this.filtro = { empresa: null, busqueda: '', verHabilitados: true }
      this.modelos = []
      this.modelosFiltrados = []
    }
  }
}
</script>
